import React from 'react';
import { View } from 'react-native';
import { Field, FormSection } from 'redux-form';
import {
  heightChecksImperial,
  i18n,
  isNumber,
  isRequired,
  maxHeight,
  minHeight,
} from '../../../utils';
import { default as ImperialHeightInput } from '../ImperialHeightInput';
import { default as TextInput } from '../TextInput';

interface IProps {
  useImperialUnit: boolean;
  t(key: string, options?: any): string;
  onBlur(e: any): void;
}

export class HeightField extends React.Component<IProps> {
  public render() {
    const { onChange, textInputStyle, useImperialUnit, inputContainerStyle, errorTextStyle, showLabel,
      placeHolderTextStyle, hasPlaceholder = true, autoFocus = false } = this.props;
    const form = !useImperialUnit ? (
      <View style={{width: '100%'}}>
          <Field
            {...this.props}
            forwardRef
            name='height'
            component={TextInput}
            autoCapitalize='none'
            placeholder={hasPlaceholder ? i18n.t(`formFields:heightWithoutMetric`) : ''}
            keyboardType='numeric'
            isRequired={true}
            returnKeyType='done'
            validate={[isRequired, isNumber, maxHeight, minHeight]}
            ref={(ref) => {
              // this.heightInput = ref;
            }}
            onChange={onChange}
            autoFocus={autoFocus}
            showLabel={!!showLabel}
            textInputStyle={textInputStyle}
            placeHolderTextStyle={placeHolderTextStyle}
            unitSuffixText={i18n.t('formFields:cm')}
          />
        </View>) :
      (
      <Field
        {...this.props}
        forwardRef
        name='heightImperial'
        showLabel={!!showLabel}
        autoFocus={autoFocus}
        onChange={onChange}
        component={ImperialHeightInput}
        validate={[heightChecksImperial]}
        textInputStyle={textInputStyle}
        inputContainerStyle={inputContainerStyle}
        placeHolderTextStyle={placeHolderTextStyle}
        errorTextStyle={errorTextStyle}
      ></Field>
      );

    return (<FormSection>{form}</FormSection>);
  }
}
